import { createApp } from 'vue'
import { renderZataReviewForm, resetZetaReviewForm } from '~/js/zeta/review'
import { searchProducts } from '~/js/helpers/searchProducts'
import OSProduct from '~/js/models/OSProduct'

const ID = 'js-pageReviewPost'
document.addEventListener('DOMContentLoaded', async () => {
  const elementPageReviewPost = document.getElementById(ID)
  if (!elementPageReviewPost) return

  createApp({
    name: 'PagesReviewPost',
    data() {
      return {
        employeeId: '',
        isEditingAdvanceInfo: true,
        nickname: '',
        searchKeyword: '',
        selectedProduct: {},
        products: [],
      }
    },
    computed: {
      isAdvanceInfoValid() {
        return !!this.employeeId && !!this.nickname
      },
    },
    mounted() {
      this.onSearchClick()
    },
    methods: {
      onNextClicked() {
        this.isEditingAdvanceInfo = false
      },
      async onSearchClick() {
        this.products = []
        try {
          const { products } = await searchProducts({
            keyword: this.searchKeyword,
            limit: 5,
          })
          this.products = products
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log(error)
        }
      },
      async onProductSelected(product) {
        this.selectedProduct = new OSProduct(product)

        await renderZataReviewForm(elementPageReviewPost, {
          employeeId: `ff-${this.employeeId}`,
          reviewerName: this.nickname,
          imageUrl: this.selectedProduct.productImage,
          itemName: this.selectedProduct.plainTitle,
          sku: this.selectedProduct.sku,
          color: this.selectedProduct.color,
          itemGroupId: this.selectedProduct.itemGroupId,
        })
        const elementInputColor = document.querySelector(
          'input.zv-prefill[name=color]'
        )
        if (elementInputColor) {
          elementInputColor.value = this.selectedProduct.color
        }
      },
      onReturnClicked() {
        this.selectedProduct = {}
        resetZetaReviewForm()
      },
      editAdvanceInfoInput() {
        this.isEditingAdvanceInfo = true
        this.selectedProduct = {}
        resetZetaReviewForm()
      },
    },
  }).mount(elementPageReviewPost)
})
